<template>
  <div class="mt-8 mb-8">
    <h1 class="page-title">
      {{ module_name }}
    </h1>
  </div>

  <div
    v-if="load_general_data"
    class="bg-white shadow overflow-hidden sm:rounded-md"
  >
    <ul role="list" class="divide-y divide-slate-200">
      <li
        v-for="packing_house_process in packing_house_processes"
        :key="packing_house_process.id"
      >
        <div
          class="block hover:bg-slate-50 cursor-pointer"
          @click.prevent="goToShowProcess(packing_house_process)"
        >
          <div class="px-4 py-4 sm:px-6">
            <div class="flex items-center justify-between">
              <p class="text-sm font-medium text-gray-900 truncate">
                {{ packing_house_process.name }}
              </p>
              <div class="ml-2 flex-shrink-0 flex">
                <a class="link invisible sm:visible"
                  ><i class="fa-solid fa-pen"></i>
                  <span class="space-icon"></span>Gestionar
                </a>
              </div>
            </div>
            <div class="mt-1 sm:flex sm:justify-between">
              <div class="sm:flex">
                <p class="mt-2 flex items-center text-sm text-gray-500 sm:mt-0">
                  <i
                    class="fa-solid fa-truck-container flex-shrink-0"
                    aria-hidden="true"
                  />
                  <span class="space-icon"></span>
                  {{
                    packing_house_process.packing_house_process_stat
                      ?.num_containers
                  }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </li>
    </ul>
  </div>
  <loading-message v-else />
</template>

<script>
import Requester from "@/views/packing_house/requesters/production/uniq_final_packing_list.js";

export default {
  name: "PHProductionBasicContainerExportShowProcesses",
  components: {},
  props: ["packing_house_id"],
  data() {
    return {
      load_general_data: false,
      packing_house_processes: [],
    };
  },
  methods: {
    fetchPackingHouseProcesses: async function () {
      let response = await Requester.fetchPackingHouseProcesses(
        this.packing_house_id
      );
      this.packing_house_processes = response.data;
      this.load_general_data = true;
    },
    goToShowProcess: function (packing_house_process) {
      this.$router.push({
        name: this.routeName("show_process"),
        params: {
          packing_house_process_id: packing_house_process.id,
        },
      });
    },
  },
  created() {
    this.checkIfAuthenticated().then(() =>
      this.checkIfAuthorized({
        role: this.$route.meta.role,
        permission: this.$route.meta.permission,
        entity: {
          packing_house_id: this.packing_house_id,
        },
      }).then(() => this.fetchPackingHouseProcesses())
    );
  },
};
</script>
